import UploadZipStep from "../../../components/UploadZipStep/UploadZipStep";

const Step2 = (props) => {
    return (
        <UploadZipStep
            {...props}
            stepTitle="STEP 2 - Upload Purchase Order Documents (ZIP)"
            description="Include scanned copies of purchase orders, viable reports, and proof of delivery in a ZIP file (Max size: 20MB)."
            filePrefix="PO"
            uploadPathPrefix="invoices"
        />
    );
};

export default Step2;